import script from "./RecruitmentAnnouncement.vue?vue&type=script&setup=true&lang=js"
export * from "./RecruitmentAnnouncement.vue?vue&type=script&setup=true&lang=js"

import "./RecruitmentAnnouncement.vue?vue&type=style&index=0&id=c9620010&scoped=true&lang=css"

import exportComponent from "/home/sino/SinoData/jenkins/.jenkins/workspace/enterpriseprodex/sxpf-cms-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9620010"]])

export default __exports__